/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingTemplateModel } from '../../models/onboarding-template-model';

export interface AdminOnboardingTemplatesFhirIdGet$Params {
  fhirId: string;
}

export function adminOnboardingTemplatesFhirIdGet(http: HttpClient, rootUrl: string, params: AdminOnboardingTemplatesFhirIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OnboardingTemplateModel>>> {
  const rb = new RequestBuilder(rootUrl, adminOnboardingTemplatesFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OnboardingTemplateModel>>;
    })
  );
}

adminOnboardingTemplatesFhirIdGet.PATH = '/Admin/OnboardingTemplates/{fhirId}';
